module.exports = __webpack_public_path__ + "static/media/DC_F_Jacquard_Vela_DK Grey_LT Grey.ee04c437.png";